export default {
  '0001': '214-741-6911',
  '0002': '214-363-8311',
  '0003': '817-738-3581',
  '0004': '713-621-7100',
  '0005': '305-865-6161',
  '0006': '404-266-8200',
  '0007': '314-567-9811',
  '0009': '847-564-0300',
  '0010': '310-550-5900',
  '0011': '949-759-1900',
  '0012': '415-362-3900',
  '0013': '972-629-1700',
  '0014': '914-428-2000',
  '0015': '702-731-3636',
  '0016': '619-692-9100',
  '0017': '630-572-1500',
  '0019': '312-642-5900',
  '0020': '617-536-3660',
  '0023': '703-761-1600',
  '0024': '650-329-3300',
  '0025': '973-912-0080',
  '0027': '303-329-2600',
  '0028': '201-291-1920',
  '0029': '480-990-2100',
  '0030': '610-354-0500',
  '0031': '808-951-8887',
  '0033': '248-643-3300',
  '0034': '786-999-1000',
  '0035': '813-877-5700',
  '0036': '407-264-5900',
  '0037': '210-558-8000',
  '0038': '561-417-5151',
  '0101': '512-719-1200',
  '0102': '704-442-7900',
  '0103': '508-620-5700',
  '0105': '818-316-7000',
  '0111': '516-368-0500',
};
